export const ROLE_2FA_AUTH_REQUIRED = "ROLE_2FA_AUTH_REQUIRED";
